const checkTypeList = [
    {name: "未备案", id: 0},
    {name: "备案中", id: 1},
    {name: "已接收", id: 2},
    {name: "已拒绝", id: 3},
    {name: "勿备案", id: 4},
    {name: "免备案", id: 5},
];

const checkResultList = [
    {name: "未检定", id: 0},
    {name: "已检定", id: 1},
    {name: "待报检", id: 2},
    {name: "未受理", id: 3},
    {name: "已超期", id: 5},
    {name: "已报检", id: 6},
    {name: "无匹配", id: 7},
    {name: "已受理", id: 8},
    {name: "待受理", id: 9},
    {name: "待具证", id: 10},
    {name: "已具证", id: 11},
    {name: "已终止", id: 12},
    {name: "已中止", id: 13},
    {name: "已校准", id: 14},
    {name: "已测试", id: 15},
];
const agingStateList= [
    {name: "过期失效", id: 0},
    {name: "现行有效", id: 1},
    {name: "已被替代", id: 2},
    {name: "即将到期", id: 3},
    {name: '注销封存', id: 4}
]


const materialTypeList = [
    {name: '钢铁成分分析标准物质', val: 1},
    {name: '有色金属及金属中气体成分分析标准物质', val: 2},
    {name: '建材成分分析标准物质', val: 3},
    {name: '高分子材料特性测量标准物质', val: 4},
    {name: '化工产品成分分析标准物质', val: 5},
    {name: '地质矿产成分分析标准物质', val: 6},
    {name: '环境化学分析标准物质', val: 7},
    {name: '临床化学分析与药品成分分析标准物质', val: 8},
    {name: '食品成分分析标准物质', val: 9},
    {name: '煤炭石油成分分析和物理特性测量标准物质', val: 10},
    {name: '核材料成分分析与放射性测量标准物质', val: 11},
    {name: '物理特性与物理化学特性测量标准物质', val: 12},
    {name: '工程技术特性测量标准物质', val: 13}
]

// 当前环节 useType 1 待办业务  0 业务大厅
const homePageList = [
    {name: "现行有效计量标准数量", key: 'measuringStandard', count: 0},
    {name: "现行有效社会公用计量标准数量", key: 'publicMeasurementStandards', count: 0},
    {name: "现行有效授权检定项目数量", key: 'authorizedVerificationItems', count: 0},
    {name: "现行有效强检项目数量", key: 'mandatoryInspectionItems', count: 0},
    {name: "强检工作计量器具用户数量", key: 'usersOfMeasuringInstruments', count: 0},
    {name: "已备案在用强检工作计量器具数量", key: 'equipmentInUse', count: 0},
    {name: "已备案停用强检工作计量器具数量", key: 'discontinuedEquipment', count: 0},
    {name: "已备案禁用强检工作计量器具数量", key: 'disableEquipment', count: 0},
    // {name: "超期未检强检工作计量器具用户数量", key: 'overdueUser', count: 0},
    // {name: "超期未检强检工作计量器具数量", key: 'overdueInstrument', count: 0},
    // {name: "已检定强检工作计量器具数量", key: 'calibratedMeasuringInstrument', count: 0},
    // {name: "强检工作计量器具检定率(已检在用/已备在用)", key: 'instrumentVerificationRate', count: 0},
];
export {checkTypeList, checkResultList, agingStateList, materialTypeList, homePageList};
